import _ from "lodash";
import React from "react";

import { useI18n } from "Hooks";
import {
  getAssociatedIconInfo,
  getRatingHistoryParentType,
} from "ClassProgressSummary/modules/Utils";

import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import { ObservationIcon } from "SvgComponents";

import {
  ImageSquareOutlined,
  LinkOutlined,
  NoteOutlined,
  PlaceholderFileOutlined,
  PlayCircleOutlined,
  ProgressReportDuotone,
} from "@toddle-edu/ds-icons";
import { Avatar } from "@toddle-edu/ds-web";
import classes from "./Thumbnail.scss";

const ICON_MAPPER = {
  FILE: <PlaceholderFileOutlined variant="on" />,
  IMAGE: <ImageSquareOutlined variant="on" />,
  NOTE: <NoteOutlined variant="on" />,
  LINK: <LinkOutlined variant="on" />,
  VIDEO: <PlayCircleOutlined variant="on" />,
};

const Thumbnail = props => {
  const { parentType, parent, displayOn, isPopUp, thumbnailSize } = props;
  const { t } = useI18n(["common"]);

  const showSmallIcon = isPopUp && displayOn === "list";
  const styles = {
    smallIconContainer: {
      width: `${thumbnailSize}`,
      height: `${thumbnailSize}`,
    },
  };
  const ratingParentType = getRatingHistoryParentType({
    parent,
    parentType,
  });
  switch (ratingParentType) {
    case "STUDENT_PROGRESS_REPORT": {
      return (
        <div
          className={classes.progressReportIconContainer}
          style={thumbnailSize && styles.smallIconContainer}
        >
          <ProgressReportDuotone
            color="pink"
            size={showSmallIcon ? "xx-small" : "small"}
          />
        </div>
      );
    }

    case "STUDENT_ASSESSMENT_EVALUATION":
    case "STUDENT_ASSIGNMENT": {
      const {
        iconColor = "neutral",
        iconAssessmentTypeLabel,
      } = getAssociatedIconInfo({
        parentType: ratingParentType,
        parent,
        t,
      });

      if (displayOn === "list") {
        return (
          <Avatar
            shape="square"
            shade="light"
            color={iconColor}
            name={iconAssessmentTypeLabel}
            size={showSmallIcon ? "x-small" : "medium"}
          />
        );
      } else {
        const imageObjectPath =
          ratingParentType === "STUDENT_ASSIGNMENT"
            ? "assignment.content.image"
            : "assessment.image";
        const imageId = _.get(parent, `${imageObjectPath}.id`, {});
        const imageUrl = _.get(parent, `${imageObjectPath}.value`, null);

        return imageUrl ? (
          <div className={classes.assessmentImageHolder}>
            <ResourceImagePlaceHolder
              id={imageId}
              imageUrl={imageUrl}
              imageThumbSize={60}
            />
          </div>
        ) : (
          <div className={classes.iconAssessmentTypeHolder}>
            <Avatar
              size="medium"
              shape="square"
              shade="light"
              color={iconColor}
              name={iconAssessmentTypeLabel}
            />
          </div>
        );
      }
    }

    case "POST": {
      const { attachments } = parent;
      const attachmentType = _.get(_.first(attachments), "type", "IMAGE");
      return (
        <div
          className={classes.postIcon}
          style={thumbnailSize && styles.smallIconContainer}
        >
          {ICON_MAPPER[attachmentType]}
        </div>
      );
    }

    default: {
      return (
        <div
          className={classes.observationIcon}
          style={thumbnailSize && styles.smallIconContainer}
        >
          <ObservationIcon />
        </div>
      );
    }
  }
};

export default Thumbnail;
